module.exports = __webpack_public_path__ + "img/green.f37b0b74.jpg";